import { render, staticRenderFns } from "./DepartmentUserForm.vue?vue&type=template&id=711562ac"
import script from "./DepartmentUserForm.vue?vue&type=script&lang=js"
export * from "./DepartmentUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports